export const ViewBranchCampaignsPermissions = {
  ViewBranchCampaigns: {
    "permissionsId": "02474164-6cff-4a33-da5d-08dddd9c3a26",
    "permissionsName": "View Branch Campaigns",
    "componentsId": null,
    "components": null,
  },
};